import React from 'react';
import { Helmet } from 'react-helmet';

import {
	innerWrapperStyle,
	wrapperStyle,
	titleStyle,
  resourceWrapper,
} from 'inside-out/page-styles/medicare';

import {
  purple,
	contentSection,
} from 'inside-out/global-styles';

import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard'

const MedicareForGPsPage = () => (<React.Fragment>
  <Helmet title="Medicare for GPs">
    <meta property="og:type" content="website" />
    <meta property="og:title" content="Medicare for GPs" /> 
    <meta name="description" content="Medicare for GPs" />
    <meta property="og:description" content="Medicare for GPs" />
  </Helmet>

  <section className={contentSection(purple)}>
    <div className={innerWrapperStyle}>
      <h1 className={titleStyle} style={{color: '#FFF', margin: '0 0 150px'}}>Medicare for GPs</h1>
    </div>
  </section>

  <section className={contentSection('none')} style={{marginTop: '-200px' }}>
    <div className={innerWrapperStyle} style={{display: 'flex' }}>
      <div className={resourceWrapper}>
        <ResourceCard
          background={ null }
          to={ '/resource-library/eating-disorder-care-plan' }
          audiences={ [] }
          title={ 'Eating Disorder Care Plan' }
          body={ 'The medical practitioner can use this template to complete the Eating Disorder Care Plan' }
        />
      </div>
      <div className={resourceWrapper}>
        <ResourceCard
          background={ null }
          to={ '/resource-library/eating-disorder-examination-questionnaire-ede-q' }
          audiences={ [] }
          title={ 'EDE-Q' }
          body={ 'This is a self-report version of the Eating Disorder Examination tool which assesses eating disorder pathology.' }
        />
      </div>
      <div className={resourceWrapper}>
        <ResourceCard
          background={ null }
          to={ '/resource-library/gp-care-plan-review-template' }
          audiences={ [] }
          title={ 'GP Care Plan Review Template' }
          body={ 'The medical practitioner can use this template to complete the Eating Disorder Care Plan Review at session 10, 20 and 30.' }
        />
      </div>
      <div className={resourceWrapper}>
        <ResourceCard
          background={ null }
          to={ '/medicare/for-health-professionals' }
          audiences={ [] }
          title={ 'For Health Professionals' }
          body={ 'For more details, see our Medicare for Health Professionals page' }
        />
      </div>
    </div>
  </section>
</React.Fragment>);

export default MedicareForGPsPage



// WEBPACK FOOTER //
// ./src/pages/medicare/for-gps/index.js